import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import Slider from "react-slick";

// Helper to get images from API only (no dummy/fallback images)
const getImpactImages = (donationData) => {
  if (donationData?.monthly_image_carousel && Array.isArray(donationData.monthly_image_carousel) && donationData.monthly_image_carousel.length > 0) {
    return donationData.monthly_image_carousel.map(item => {
      if (typeof item === 'string') return item;
      if (item && typeof item === 'object' && item.url) return item.url;
      return item;
    }).filter(Boolean);
  }
  return [];
};

const YourImpactSlider = ({ donationData }) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery('(min-width: 900px) and (max-width: 1200px)');
  const isSmallScreen = useMediaQuery('(max-width: 899px)');
  const isMobile = useMediaQuery('(max-width: 600px)');

  const images = getImpactImages(donationData);
  if (images.length === 0) return null;

  const donorCount = donationData?.totalDonors ?? donationData?.Totaldonors ?? donationData?.total_donors ?? 0;
  const formattedDonorCount = donorCount.toLocaleString('en-IN');

  const sliderSettings = {
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    cssEase: 'linear',
    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: false,
    swipe: false,
    touchMove: false,
    variableWidth: true,
    slidesToScroll: 1,
    centerMode: false,
  };

  const slideCardWidth = isMobile ? 122 : 340;
  const slidePadding = isMobile ? 1 : 3;
  const totalSlideWidth = slideCardWidth + slidePadding;

  return (
    <Box sx={{ width: "100%", mx: "auto", mt: isMobile ? "20px" : 4, px: 0 }}>
      <Box sx={{ textAlign: "center", mb: isMobile ? "20px" :isSmallScreen?"60px":isMediumScreen?"60px": "124px" }}>
        <Typography
          sx={{
            textAlign: "center",
            fontSize: isMobile ? "10px" : "14px",
            color: "#131313",
            fontWeight: 400,
            letterSpacing: "0.1em",
            mb: 2,
            textTransform: "uppercase",
          }}
        >
          YOUR IMPACT
        </Typography>
        
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: isMobile ? 1 : 2,
            textAlign: "center",
            maxWidth: "980px",
            mx: "auto",
            mb: isMediumScreen?"10px":isSmallScreen?"10px":2,
          }}
        >
			<Box
				sx={{
					width: isMobile ? 10 : 12,
					height: isMobile ? 10 : 12,
					borderRadius: "50%",
					backgroundColor: "#A9C74E",
					flexShrink: 0,
					'@keyframes liveBlink': {
						'0%': { opacity: 1, transform: 'scale(1)' },
						'50%': { opacity: 0.3, transform: 'scale(0.8)' },
						'100%': { opacity: 1, transform: 'scale(1)' },
					},
					animation: 'liveBlink 1.2s ease-in-out infinite',
				}}
			/>
          <Typography
            component="span"
            sx={{
              fontSize: isMobile ? "16px" :isSmallScreen?"24px": isMediumScreen?"30px":"44px",
              fontWeight: 600,
              color: "#141414",
              lineHeight: isMobile ? 1.3 : 1.2,
            }}
          >
            {formattedDonorCount} caring souls have already pledged
          </Typography>
        </Box>

        <Typography
          sx={{
            textAlign: "center",
            fontSize: isMobile ? "16px" :isSmallScreen?"24px": isMediumScreen?"30px":"44px",
            color: "#686866",
            fontWeight: 400,
            lineHeight: 1.4,
          }}
        >
          {donationData?.monthly_header_description ?? ""}
        </Typography>
      </Box>

      <Box sx={{ width: "100%", overflow: "hidden", px: 0, height: isMobile ? "157.888px" : "440px" }}>
        <Slider {...sliderSettings}>
          {[...images, ...images].map((img, idx) => (
            <Box
              key={idx}
              sx={{
                width: totalSlideWidth,
                px: slidePadding / 2,
                outline: "none",
                boxSizing: "border-box",
              }}
            >
              <Box
                component="img"
                src={img}
                alt={`impact-${idx}`}
                sx={{
                  width: slideCardWidth,
                  height: isMobile ? "157.888px" : "440px",
                  objectFit: "cover",
                  borderRadius: isSmallScreen ? "4px" : "12px",
                  boxShadow: 2,
                  display: "block",
                }}
              />
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default YourImpactSlider;